import { Button, Box } from '@mui/material'
import DialogBase from 'components/dialog/Base'
import UIField from 'components/ui/Field'
import FormInput from 'components/ui/FormInput'
import { FilterObjectState } from 'components/UsageLog/UsageLog'
import { useForm, FormProvider } from 'react-hook-form'

const ResetButton = (props) => <Button variant="outlined" sx={{ ml: 0.7 }} {...props} />
const Field = (props) => <UIField inline labelWidth={150} {...props} />
const Input = (props) => <Box display="flex" sx={{ textAlign: 'left' }} {...props} />

const STATUS_OPTIONS = [
  {
    label: '正常',
    value: 'OK',
  },
  {
    label: '異常',
    value: 'NG',
  },
]

const OPERATION_OPTIONS = [
  {
    label: 'ログイン',
    value: 'LOGIN',
  },
  {
    label: 'ログアウト',
    value: 'LOGOUT',
  },
  {
    label: '新規登録',
    value: 'NEW',
  },
  {
    label: '結果編集',
    value: 'UPDATE',
  },
  {
    label: '結果出力',
    value: 'EXPORT',
  },
]

type Props = {
  open: boolean
  setOpenDialog: (x: boolean) => void
  filterObject: FilterObjectState
  setFilterLog: (newFilterObject: FilterObjectState) => void
}

export default function FilterLogDialog({
  open,
  setOpenDialog,
  filterObject,
  setFilterLog,
}: Props) {
  const form = useForm({
    defaultValues: filterObject,
  })
  const { reset, handleSubmit, setValue } = form

  const close = () => {
    reset(filterObject)
    setOpenDialog(false)
  }

  const submit = handleSubmit((data: FilterObjectState) => {
    setFilterLog(data)
    reset(data)
  })

  return (
    <DialogBase
      open={open}
      title="条件変更"
      onCancel={close}
      onClose={close}
      onAction={submit}
      actionText="確定"
      cancelText="キャンセル"
    >
      <FormProvider {...form}>
        <Box style={{ marginTop: 2 }}>
          <Field label="操作" labelFor="filter-operation">
            <Input>
              <FormInput
                name="action"
                type="select"
                options={OPERATION_OPTIONS}
                testid="usage-log-operation"
              />
              <ResetButton
                onClick={() => setValue('action', '')}
                data-testid="usage-log-operation-reset-button"
              >
                リセット
              </ResetButton>
            </Input>
          </Field>
          <Field label="文書名" labelFor="filter-documentName">
            <Input>
              <FormInput name="document_name" type="text" testid="usage-log-document-name" />
              <ResetButton
                onClick={() => setValue('document_name', '')}
                data-testid="usage-log-document-name-reset-button"
              >
                リセット
              </ResetButton>
            </Input>
          </Field>
          <Field label="ステータス" labelFor="filter-status">
            <Input>
              <FormInput
                name="status"
                type="select"
                options={STATUS_OPTIONS}
                testid="usage-log-status"
              />
              <ResetButton
                onClick={() => setValue('status', '')}
                data-testid="usage-log-status-reset-button"
              >
                リセット
              </ResetButton>
            </Input>
          </Field>
          <Field label="メッセージ" labelFor="filter-message">
            <Input>
              <FormInput name="message" type="text" testid="usage-log-message" />
              <ResetButton
                onClick={() => setValue('message', '')}
                data-testid="usage-log-message-reset-button"
              >
                リセット
              </ResetButton>
            </Input>
          </Field>
          <Field label="利用者名" labelFor="filter-userName">
            <Input>
              <FormInput name="user_name" type="text" testid="usage-log-username" />
              <ResetButton
                onClick={() => setValue('user_name', '')}
                data-testid="usage-log-username-reset-button"
              >
                リセット
              </ResetButton>
            </Input>
          </Field>
        </Box>
      </FormProvider>
    </DialogBase>
  )
}
